<template>
    <el-dialog
        class="edit-tracking-number"
        :visible.sync="trackingVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        :modal-append-to-body="false"
        append-to-body
        width="650px"
        title="Edit Tracking Number"
    >
        <el-form
            ref="trackingForm"
            :model="trackingForm"
            :rules="rules"
            label-width="130px"
        >
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item
                        label="Express"
                        prop="last_mile"
                        size="small"
                    >
                        <el-select
                            clearable
                            filterable
                            v-model="trackingForm.last_mile"
                            placeholder="Please select"
                        >
                            <el-option
                                v-for="item in channelList"
                                :key="item.last_mile"
                                :label="item.last_mile"
                                :value="item.last_mile"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Tracking Number" prop="tracking_number" size="small">
                        <el-input
                            size="small"
                            placeholder="Tracking Number"
                            v-model="trackingForm.tracking_number"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Shipped" prop="shipped" size="small">
                        <el-checkbox v-model="trackingForm.shipped"></el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="trackingVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            trackingForm: {
                last_mile: "",
                tracking_number: "",
                shipped: "",
            },
            rules: {
                last_mile: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "Express is required"
                    },
                ],
                tracking_number: [
                    {
                        required: true,
                        trigger: "blur",
                        message: "Tracking Number is required"
                    },
                ],
            },
            countryList: [],
            channelList: [],
        };
    },
    methods: {
        ...mapActions(["getExpressSelect"]),
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.$refs["trackingForm"].clearValidate();
            this.$refs["trackingForm"].resetFields();
            this.$emit("update:trackingVisible", false);
        },
        /**
         *  保存
         */
        save() {
            this.$refs["trackingForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .updateTrackno(
                            {
                                ...this.trackingForm,
                                order_id: this.tableItem.id
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res && res.errcode === 0) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        /* updateTrackno() {
            cmofferApi
                .updateTrackno({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.trackingForm = { ...res.data };
                    }
                });
        }, */
    },
    props: {
        trackingVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        trackingVisible(val) {
            if (val) {
                // this.updateTrackno();
                console.log(this.tableItem);
                this.trackingForm.last_mile = this.tableItem.last_mile;
                this.trackingForm.tracking_number = this.tableItem.tracking_number;
                cmofferApi
                .lastMileSelect({}, "get")
                .then((res) => {
                    if (res) {
                        this.channelList = res.data;
                    }
                });
            }
        },
    },
};
</script>
<style lang="scss">
.edit-tracking-number {
    .el-form-item__content {
        .el-select,
        .el-select--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
    .el-row {
        &:only-child {
            margin-bottom: 0;
        }
        & + .el-row {
            margin-top: 18px;
        }
    }
}
</style>
